import React from 'react'
import ImageUploader from '../../ImageUpLoader'
import { SectionCard } from './SectionCard'
import styles from './styles.module.css'

export const MediaSection = ({
  imageFile, setImageFile,
  previewUrl, setPreviewUrl,
  ingredientImageFile, setIngredientImageFile,
  ingredientPreviewUrl, setIngredientPreviewUrl
}) => (
  <SectionCard title='Product Media'>
    <div className={styles.mediaRow}>
      <div className={styles.uploadBox}>
        <div className={styles.uploadLabel}>Product Image</div>
        <ImageUploader
          onChange={file => setImageFile(file)}
          imageFile={imageFile}
          setImageFile={setImageFile}
          previewUrl={previewUrl}
          setPreviewUrl={setPreviewUrl}
        />
      </div>

      <div className={styles.uploadBox}>
        <div className={styles.uploadLabel}>Ingredients Image</div>
        <ImageUploader
          onChange={file => setIngredientImageFile(file)}
          imageFile={imageFile}
          setImageFile={setImageFile}
          previewUrl={previewUrl}
          setPreviewUrl={setPreviewUrl}
          ingredientImageFile={ingredientImageFile}
          setIngredientImageFile={setIngredientImageFile}
          ingredientPreviewUrl={ingredientPreviewUrl}
          setIngredientPreviewUrl={setIngredientPreviewUrl}
          imageFor='ingredients-image'
        />
      </div>
    </div>
  </SectionCard>
)
